<template>
  <div class="i-coaching-ad">
    <div class="header">Upgrade to 1:1 Coaching</div>
    <div class="sub">Fast-track your career with personalized coaching from industry experts.</div>
    <div class="note"><img :src="iconStar" /> 4.9/5 average rating <span>•</span> 500+ success stories</div>
    <div class="included">
      <div
        v-for="(item, index) in INCLUDED"
        :key="index"
        class="item"
      >
        <img :src="iconCheck" />
        <div>{{ item }}</div>
      </div>
    </div>
    <iBaseButton
      v-bind="BUTTON_STYLE"
      text="Start 1:1 Coaching Today"
      @clicked="linkToCoachSelection"
    />
  </div>
</template>

<script setup lang="ts">
// COMPOSABLES
import linkToCoachSelection from "@/composables/linkToCoachSelection"

// COMPONENTS
import iBaseButton from "@/components/base/BaseButton.vue"

// ASSETS
import iconCheck from "@/assets/icons/icon-circle-black-check.svg"
import iconStar from "@/assets/icons/icon-single-gold-star.svg"
import iconArrow from "@/assets/icons/icon-arrow-right-white.svg"

// STYLES
import { bluePurpleGradient, white } from "@/styles/colors"

// CONSTANTS
const BUTTON_STYLE = {
  backgroundImage: bluePurpleGradient,
  borderRadius: "8px",
  fontWeight: "500",
  textColor: white,
  size: "small",
  width: "100%",
  padding: "12px 12px",
  iconUrl: iconArrow
}
const INCLUDED = ["1:1 Career Coaching", "Dedicated Career Coach", "Step-by-step Guidance", "Ongoing Support"]
</script>

<style lang="scss" scoped>
.i-coaching-ad {
  @include flex(column, start, start, $gap: 18px);
  @include border-radius-md;
  @include text-sm;

  border: 1px solid $zumthor100;
  width: 100%;
  padding: 18px;
  text-align: start;
  color: $pickle-bluewood950;

  .header {
    @include text-lg;

    font-weight: 600;
  }

  .sub {
    @include text-xs;

    color: $comet600;
  }

  .note {
    @include flex(row, start, center, wrap, 5px);
    @include text-xxs;

    color: $comet700;
  }

  .included {
    @include flex(column, start, stretch, $gap: 16px);

    .item {
      @include flex(row, start, center, $gap: 5px);
      @include text-sm;

      font-weight: 600;
    }
  }
}
</style>
